import type { FaireProductEntity } from "../../entity_types/product";

export const p_fj7v5hvneb: FaireProductEntity = {
  token: "p_fj7v5hvneb",
  type: "product",
  name: "Cookie Dough 1/2 lb. Fudge Bar",
  brandToken: "b_5021dx08mu",
  brandName: "Valley Fudge & Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/783d9e7e53c10a3dd35851001ddeb7bdc2b315f3729e9e4e07aa2648a0dfe5f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/979da31224487f9222d814df0e75de2c8bbaa9e5f3008571efa9a2fed07a9433.jpeg",
    "https://cdn.faire.com/fastly/2658cc96d6fea5bd1f3228359f3a9ed9093392e3be99f0d1ce01ffe69035574f.png",
  ],
  priceDollars: 6.86,
  description:
    "Our Fudge is always made with  fresh high quality ingredients, including 100% Real Wisconsin Butter! Cookie dough lovers rejoice! Each piece of fudge is packed with chunks of soft, buttery chocolate chip cookie dough, providing the perfect balance of sweetness and texture. Cookie Dough Fudge is sure to please!\n\nWholesale Message: To keep it simple and convenient for your business, we sell fudge by the individual package. This means you can purchase as many packages of any flavor as you would like. There is no limit required. The more fudge packages, the merrier!\n\nSale Shelf Life: We make all fudge fresh to order and ship it upon packaging. This provides 7-8 weeks of sale shelf life for your company.\n\nMerchandising Your Fudge: Your fudge is best merchandised at room temperature and out of direct sunlight.\n",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:32.850Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
